//noScroll
class TableSpScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let el = $('<div class="sp c-table-scroll__trigger js-table-scroll-trigger"></div>')
    $('.js-table-scroll').append(el);

    // -----------------------------------
    // 沿革 横スクロール
    // -----------------------------------

    var scrollInterval;

    $('.js-table-scroll-trigger').on('mousedown touchstart', function() {
      console.log($(this).prev());
      var $container = $(this).prev();
      startScrolling($container, 'right');
    });

    $(document).on('mouseup touchend touchcancel', stopScrolling);

    function startScrolling($container, direction) {
      var scrollAmount = 2; // スクロール量をピクセル単位で設定

      scrollInterval = setInterval(function() {
        if (direction === 'right') {
          $container.scrollLeft($container.scrollLeft() + scrollAmount);
        } else {
          $container.scrollLeft($container.scrollLeft() - scrollAmount);
        }
      }, 1); // 50ミリ秒ごとにスクロール
    }

    function stopScrolling() {
      clearInterval(scrollInterval);
    }
  }
}